import { makeAuthenticatedRequestWithHandling } from "./api";

export const getChannelDetailsById = async (channelId) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/channels/${channelId}`
    );
    return await response?.json();
  } catch (error) {
    console.error("Error during creating assessments:", error);
    return { ok: false, error: error };
  }
};

export const getListOfAllDiscussionChannel = async ({
  classroomId,
  page = 0,
  pageSize = 10,
}) => {
  try {
    const URL = `/channels/classroom/${classroomId}?pageNumber=${page}&pageSize=${pageSize}`;
    const response = await makeAuthenticatedRequestWithHandling(URL);
    return await response?.json();
  } catch (error) {
    console.error("Error during creating assessments:", error);
    return { ok: false, error: error };
  }
};

export const getListOfAllNotifications = async ({
  page = 0,
  pageSize = 10,
  addReadFlag = false,
  flag = false,
}) => {
  try {
    let URL = `/notifications?pageNumber=${page}&pageSize=${pageSize}`;
    if (addReadFlag) {
      URL += `&read=${flag}`;
    }
    const response = await makeAuthenticatedRequestWithHandling(URL);
    return await response?.json();
  } catch (error) {
    console.error("Error during creating assessments:", error);
    return { ok: false, error: error };
  }
};

export const markNotificationsAsRead = async (notificationId, payload) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/notifications/${notificationId}`,
      "PATCH",
      payload
    );
    return await response?.json();
  } catch (error) {
    console.error("Error during creating channel:", error);
    return { ok: false, error: error };
  }
};

export const markAlllNotificationsAsRead = async () => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/notifications/markAllAsRead`,
      "POST",
      JSON.stringify({})
    );
    return await response?.json();
  } catch (error) {
    console.error("Error during creating channel:", error);
    return { ok: false, error: error };
  }
};

export const markAlllNotificationsAsSeen = async () => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/notifications/markAllAsSeen`,
      "POST",
      JSON.stringify({})
    );
    return await response?.json();
  } catch (error) {
    console.error("Error during creating channel:", error);
    return { ok: false, error: error };
  }
};

export const deleteDiscussionChannel = async (channelId) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/channels/${channelId}`,
      "DELETE"
    );
    return response.json();
  } catch (error) {
    console.error("Error during getting assessments:", error);
    return { ok: false, error: error };
  }
};

export const createDiscussionChannel = async (classroomId, payload) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/channels/${classroomId}`,
      "POST",
      payload
    );
    return await response?.json();
  } catch (error) {
    console.error("Error during creating channel:", error);
    return { ok: false, error: error };
  }
};

export const updateDiscussionChannel = async (id, payload) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/channels/${id}`,
      "PATCH",
      payload
    );
    return await response?.json();
  } catch (error) {
    console.error("Error during creating channel:", error);
    return { ok: false, error: error };
  }
};

/**
 *
 *  All the methods below are related to the discussion channel's messages
 *
 */

export const createQuestionInChannel = async (channelId, payload) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/cquestions/${channelId}`,
      "POST",
      payload
    );
    return await response?.json();
  } catch (error) {
    console.error("Error during creating Question:", error);
    return { ok: false, error: error };
  }
};

export const updateQuestionInChannel = async (questionId, payload) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/cquestions/${questionId}`,
      "PATCH",
      payload
    );
    return await response?.json();
  } catch (error) {
    console.error("Error during creating Question:", error);
    return { ok: false, error: error };
  }
};

export const deleteQuestionInChannel = async (questionId) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/cquestions/${questionId}`,
      "DELETE"
    );
    return response.json();
  } catch (error) {
    console.error("Error during getting assessments:", error);
    return { ok: false, error: error };
  }
};

export const getListOfAllQuestionsInChannel = async ({
  channelId,
  page = 0,
  pageSize = 10,
  isVerified = "",
  isPined = "",
  searchText = "",
}) => {
  try {
    let URL = `/cquestions/channel/${channelId}?pageNumber=${page}&pageSize=${pageSize}&pinned=0`;
    if (isPined !== "") {
      URL = `/cquestions/channel/${channelId}?pinned=${isPined}`;
    }
    if (isVerified !== "") {
      URL += `&verified=${isVerified}`;
    }
    if (searchText !== "") {
      URL += `&search=${searchText}`;
    }
    const response = await makeAuthenticatedRequestWithHandling(URL);
    return await response?.json();
  } catch (error) {
    console.error("Error during creating assessments:", error);
    return { ok: false, error: error };
  }
};

export const getCountOfUnverifiedQuestions = async ({ classroomId = "" }) => {
  try {
    let URL = `/channels/unverified/${classroomId}`;
    const response = await makeAuthenticatedRequestWithHandling(URL);
    return await response?.json();
  } catch (error) {
    console.error("Error during creating assessments:", error);
    return { ok: false, error: error };
  }
};

export const getCountOfUnreadAnnouncements = async ({ classroomId = "" }) => {
  try {
    let URL = `/announcements/unread_count/${classroomId}`;
    const response = await makeAuthenticatedRequestWithHandling(URL);
    return await response?.json();
  } catch (error) {
    console.error("Error during creating assessments:", error);
    return { ok: false, error: error };
  }
};

export const MarkCountOfUnreadAnnouncements = async ({ classroomId = "" }) => {
  try {
    let URL = `/announcements/markAllAsRead/${classroomId}`;
    const response = await makeAuthenticatedRequestWithHandling(URL, "POST");
    return await response?.json();
  } catch (error) {
    console.error("Error during creating assessments:", error);
    return { ok: false, error: error };
  }
};

export const createAnswerInQuestion = async (questionId, payload) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/canswers/${questionId}`,
      "POST",
      payload
    );
    return await response?.json();
  } catch (error) {
    console.error("Error during creating Question:", error);
    return { ok: false, error: error };
  }
};

export const updateAnswerInQuestion = async (answerId, payload) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/canswers/${answerId}`,
      "PATCH",
      payload
    );
    return await response?.json();
  } catch (error) {
    console.error("Error during updating answer:", error);
    return { ok: false, error: error };
  }
};

export const deleteAnswerInQuestion = async (answerId) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/canswers/${answerId}`,
      "DELETE"
    );
    return response.json();
  } catch (error) {
    console.error("Error during delete answer:", error);
    return { ok: false, error: error };
  }
};

export const deleteAttachementInAnswer = async (answerId, s3Key) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/canswers/${answerId}/${encodeURIComponent(s3Key)}`,
      "DELETE"
    );
    return response.json();
  } catch (error) {
    console.error("Error during delete answer:", error);
    return { ok: false, error: error };
  }
};

export const deleteAttachementInQuestion = async (questionId, s3Key) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/cquestions/${questionId}/${encodeURIComponent(s3Key)}`,
      "DELETE"
    );
    return response.json();
  } catch (error) {
    console.error("Error during delete answer:", error);
    return { ok: false, error: error };
  }
};

export const getListOfAllAnswersInQuestion = async ({
  questionId,
  page = 0,
  pageSize = 10,
}) => {
  try {
    const URL = `/canswers/question/${questionId}?pageNumber=${page}&pageSize=${pageSize}`;
    const response = await makeAuthenticatedRequestWithHandling(URL);
    return await response?.json();
  } catch (error) {
    console.error("Error during creating assessments:", error);
    return { ok: false, error: error };
  }
};

/**
 *
 *  All the methods below are related to the announcements
 *
 */

export const createAnnouncement = async (classroomId, payload) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/announcements/${classroomId}`,
      "POST",
      payload
    );
    return await response?.json();
  } catch (error) {
    console.error("Error during creating Question:", error);
    return { ok: false, error: error };
  }
};

export const updateAnnouncement = async (announcementId, payload) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/announcements/${announcementId}`,
      "PATCH",
      payload
    );
    return await response?.json();
  } catch (error) {
    console.error("Error during updating Announcement:", error);
    return { ok: false, error: error };
  }
};

export const getAllAnnouncementsOfClassroom = async ({
  classroomId,
  page = 0,
  pageSize = 10,
  isVerified = "",
  isPinned = "",
  searchText = "",
}) => {
  try {
    let URL = `/announcements/classroom/${classroomId}?pageNumber=${page}&pageSize=${pageSize}&pinned=0`;
    if (isPinned !== "") {
      URL = `/announcements/classroom/${classroomId}?pinned=${isPinned}`;
    }
    if (isVerified !== "") {
      URL += `&verified=${isVerified}`;
    }
    if (searchText !== "") {
      URL += `&search=${searchText}`;
    }
    const response = await makeAuthenticatedRequestWithHandling(URL);
    return await response?.json();
  } catch (error) {
    console.error("Error during creating assessments:", error);
    return { ok: false, error: error };
  }
};

export const deleteAnnouncement = async (announcementId) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/announcements/${announcementId}`,
      "DELETE"
    );
    return response.json();
  } catch (error) {
    console.error("Error during getting assessments:", error);
    return { ok: false, error: error };
  }
};

export const getListOfAllCommentsInAnnouncement = async ({
  announcementId,
  page = 0,
  pageSize = 10,
}) => {
  try {
    const URL = `/announcement_comments/announcement/${announcementId}?pageNumber=${page}&pageSize=${pageSize}`;
    const response = await makeAuthenticatedRequestWithHandling(URL);
    return await response?.json();
  } catch (error) {
    console.error("Error during creating assessments:", error);
    return { ok: false, error: error };
  }
};

export const createComment = async (announcementId, payload) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/announcement_comments/${announcementId}`,
      "POST",
      payload
    );
    return await response?.json();
  } catch (error) {
    console.error("Error during creating Question:", error);
    return { ok: false, error: error };
  }
};

export const updateComment = async (commentId, payload) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/announcement_comments/${commentId}`,
      "PATCH",
      payload
    );
    return await response?.json();
  } catch (error) {
    console.error("Error during updating answer:", error);
    return { ok: false, error: error };
  }
};

export const deleteComment = async (commentId) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/announcement_comments/${commentId}`,
      "DELETE"
    );
    return response.json();
  } catch (error) {
    console.error("Error during delete answer:", error);
    return { ok: false, error: error };
  }
};
